const PenIcon = () => {
  return (
    <svg viewBox="0 0 18 18">
      <g transform="translate(-47.367 -47.367)">
        <path d="M62.238,47.367a1.5,1.5,0,0,0-1.061.44l-1.811,1.811,3.75,3.75,1.81-1.811a1.5,1.5,0,0,0,0-2.121L63.3,47.807A1.5,1.5,0,0,0,62.238,47.367Zm-4.371,3.75-8.807,8.8s.688-.061.946.2.044,1.934.36,2.25,1.983.094,2.221.331.226.973.226.973l8.8-8.8Zm-9.75,11.25-.709,2a.776.776,0,0,0-.041.246.751.751,0,0,0,.75.75.7.7,0,0,0,.246-.044s.006,0,.006,0l.021,0s0,0,0-.006l1.975-.694Z" />
      </g>
    </svg>
  );
};

export default PenIcon;
